import { render, staticRenderFns } from "./MenuReportSales.vue?vue&type=template&id=21d8ea3d&scoped=true&"
import script from "./MenuReportSales.vue?vue&type=script&lang=js&"
export * from "./MenuReportSales.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportSales.vue?vue&type=style&index=0&id=21d8ea3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8ea3d",
  null
  
)

export default component.exports